import ReportsScreen from "app/screens/reports/ReportsScreen";

export default function ReportsPage() {
  return <ReportsScreen />;
}
